<header class="sub-page-layout__header frequencyCode__header">
  <div class="frequencyCode__header-text h2 h2--semi-bold">Frequency Codes</div>
  <mat-slide-toggle
    class="frequencyCode__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="frequencyCode__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Frequency Codes
  </button>
  <button
    mat-flat-button
    color="primary"
    class="frequencyCode__add-item"
    (click)="addFrequencyCode()"
    *ngIf="!viewOnly"
  >
    <mat-icon>add_circle_outline</mat-icon> Add Frequency Code
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Frequency Codes Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="frequencyCode__footer">
  <lib-button-loading color="primary" class="frequencyCode__button" (clickEvent)="next()" id="nextButton"
    >Next
  </lib-button-loading>
</footer>
